import {lazy} from '@aboutyou/lazy-imports';

/**
 *
 * @param props
 * @returns
 * @deprecated shall be removed once coins is live
 */
export const CouponWalletBodyContent = lazy(() =>
  import('./CouponWalletBodyContent.eager').then(mod => ({
    default: mod.CouponWalletBodyContent,
  })),
);
